export default function getFormattedMetadata(metadata) {
    if (!metadata) return ''

    let parsedMetadata = metadata

    while (typeof parsedMetadata === 'string') {
        try {
            const nextValue = JSON.parse(parsedMetadata)
            if (nextValue === parsedMetadata) break
            parsedMetadata = nextValue
        } catch (error) {
            break
        }
    }

    return typeof parsedMetadata === 'string'
        ? parsedMetadata
        : JSON.stringify(parsedMetadata, null, 2)
}